import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';
import { z } from 'zod';

import { restoreSavedFilters } from '@@containers/Search/restoreSavedFilters';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { abTestsQuery, abTestsSearchParams } from './-components/AbTests/abTestsQuery';
import { CURATED_LIST_TAB } from './-components/constants';
import CuratedListPage from './-components/CuratedListPage';
import {
    proofreadingQuery,
    proofreadingSearchParams,
} from './-components/Proofreading/proofreadingQuery';

// The open tab, the proofreading tab's search and the AB tests tab's statuses
export const Route = createFileRoute('/_authenticated/curatedList/')({
    validateSearch: proofreadingSearchParams.extend(abTestsSearchParams.shape).extend({
        tab: z.literal(CURATED_LIST_TAB.AB_TESTS).optional().catch(undefined),
    }),
    // A new search of the open tab makes a new match, which runs the loader again
    loaderDeps: ({ search }) =>
        search.tab === CURATED_LIST_TAB.AB_TESTS
            ? { tab: search.tab, ...abTestsSearchParams.parse(search) }
            : proofreadingSearchParams.parse(search),
    beforeLoad: ({ cause, location, search }) => {
        restoreSavedFilters({ cause, location, search }, proofreadingSearchParams, 'curatedList');

        // Built on every load, so the options follow the content language as well as the search
        return {
            proofreadingQuery: proofreadingQuery(search, getContentLocale()),
            abTestsQuery: abTestsQuery(search),
        };
    },
    loader: ({ context, deps }) => {
        if ('tab' in deps) {
            context.queryClient.query(context.abTestsQuery).catch(doNothing());
        } else {
            context.queryClient.query(context.proofreadingQuery).catch(doNothing());
        }
    },
    component: CuratedListPage,
});
